module.exports = __webpack_public_path__ + "img/weixingongzhonghao.09dfc694.png";